// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3vBHH","noInteraction":"EventWrapper_noInteraction__2UBRR","pointerPassthrough":"EventWrapper_pointerPassthrough__dTHlf"};